import { Col, Container, Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import bookaseatbanner from '../assets/images/gallery/gallery-1.jpg';
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import ServiceNotFound from "../components/sections/service-not-found";

const SubService = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
  
    const [serviceData, setServiceData] = useState(null);
    const [servicesLoading, setServicesLoading] = useState(true);

    // Fetch individual service by slug from API
    useEffect(() => {
        const fetchServiceBySlug = async () => {
            if (!slug) {
                setServiceData(null);
                setServicesLoading(false);
                return;
            }

            try {
                setServicesLoading(true);
                const response = await axios.get(getApiUrl(`api/public/services/${slug}`));

                if (response.data.success && response.data.data) {
                    const data = response.data.data;
                    // Store service data with sub_services and parent's sub_services
                    setServiceData({
                        service: data.service,
                        parent: data.parent || null,
                        subServices: data.sub_services || [],
                        parentSubServices: data.parent?.sub_services || []
                    });
                } else {
                    setServiceData(null);
                }
            } catch (error) {
                console.error('Error fetching service:', error);
                setServiceData(null);
            } finally {
                setServicesLoading(false);
            }
        };

        fetchServiceBySlug();
    }, [slug]);


    // If loading, show loading state
    if (servicesLoading) {
        const defaultPageDetails = {
            title: "Service",
            description: "",
            breadcrumb: [
                { name: "Home", link: "/" },
                { name: "Services", link: "/services" }
            ],
        };
        return (
            <>
                <Banner img={Bannerimg} pageDetails={defaultPageDetails} highlightClassName="theme-color-green" />
                <div className="body-wrap overflow-hidden mt-5">
                    <section className="loading-screen height-25-p">
                        <div className="loader-wrapper">
                            <div className="spinner"></div>
                            <h4 className="loading-text">Loading ...</h4>
                        </div>
                    </section>
                </div>
            </>
        );
    }

    // If no slug or service data found (and loading is complete), show not found message
    if (!slug || (!servicesLoading && !serviceData)) {
        const defaultPageDetails = {
            title: "Service",
            description: "",
            breadcrumb: [
                { name: "Home", link: "/" },
                { name: "Services", link: "/services" }
            ],
        };
        return (
            <>
                <Banner img={Bannerimg} pageDetails={defaultPageDetails} highlightClassName="theme-color-green" />
                <div className="body-wrap overflow-hidden my-5">
                    <ServiceNotFound />
                </div>
            </>
        );
    }

    const { service, parent, subServices, parentSubServices } = serviceData;

    // Build page details
    const pageDetails = parent ? {
        title: service.title,
        description: "",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: parent.title, link: `/services/${parent.slug}` },
            { name: service.title, link: `/services/${service.slug}` }
        ],
    } : {
        title: service.title,
        description: "",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: service.title, link: `/services/${service.slug}` }
        ],
    };

    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                <section className='py-4'>
                    <div className="position-relative">
                        <div className="design-circle-our-worksection position-absolute"></div>
                        <Container>
                            <div className="studen-work-card mb-5">
                                {/* Service Image - Full Width */}
                                <div className='img-1 mb-5'>
                                    {service.image ? (
                                        <div
                                            style={{ backgroundImage: `url(${service.image})` }}
                                            className="main-blog-img img-1"
                                        />
                                    ) : (
                                        <div
                                            style={{ backgroundImage: `url(${bookaseatbanner})` }}
                                            className="main-blog-img img-1"
                                        />
                                    )}
                                </div>

                                <Row>
                                    <Col lg={8}>
                                        <div>
                                            {/* Render HTML content from API */}
                                            {service.content && (
                                                <div
                                                    className="blog-content"
                                                    dangerouslySetInnerHTML={{ __html: service.content }}
                                                />
                                            )}

                                            {/* Fallback to excerpt if content is not available */}
                                            {!service.content && service.excerpt && (
                                                <p className="blog-card-desc">{service.excerpt}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="blog-side-card">
                                            {(() => {
                                                // Check if current service has sub_services
                                                const hasSubServices = subServices && subServices.length > 0;

                                                // If has sub_services, show "Sub Services"
                                                // Otherwise, show "Related Services" from parent
                                                const title = hasSubServices ? "Sub Services" : "Related Services";

                                                // If has sub_services, use them directly
                                                // Otherwise, use parent's sub_services if available
                                                let servicesToShow = [];
                                                if (hasSubServices) {
                                                    servicesToShow = subServices;
                                                } else if (parentSubServices && parentSubServices.length > 0) {
                                                    servicesToShow = parentSubServices;
                                                }

                                                return (
                                                    <>
                                                        <h2 className="search-label mb-3">{title}</h2>
                                                        {servicesToShow.length > 0 ? (
                                                            servicesToShow.map((sub) => {
                                                                const isCurrent = sub.slug === slug;

                                                                // If current, skip rendering
                                                                if (isCurrent) return null;

                                                                return (
                                                                    <div
                                                                        key={sub.id}
                                                                        className="serive-list large d-flex mb-3"
                                                                        onClick={() => navigate(`/services/${sub.slug}`)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <div className="service-icon">
                                                                            <span className={sub.icon || 'fa-solid fa-gear'} />
                                                                        </div>

                                                                        <div className="service-desc">
                                                                            <div>
                                                                                <h2 className="sub-service-title">{sub.title}</h2>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <p>No {title.toLowerCase()} available.</p>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>
                </section>
            </div>
        </>
    )
}

export default SubService;